// extracted by mini-css-extract-plugin
export default {"modalContainer":"lw","fadeRight":"mw","fadeUp":"nw","topShelf":"ow","newFlavorBadge":"pw","transparentText":"qw","cancelButton":"rw","invisibleLink":"sw","closeIcon":"tw","linkContainer":"uw","hed":"vw","image":"ww"};
    if(module.hot) {
      // 1738836192939
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  